import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import styled from 'styled-components';
const Container = styled.nav `
  --gap: ${fluid(10, 12)};
  --colorActive: ${brand.global.red};

  &[data-site='ess'] {
    --colorInactive: ${brand.ess.secondary.darkGrey};
    --clickPadding: 0;
    --height: ${fluid(40, 60)};
    --width: 2px;
  }

  &[data-site='mep'] {
    --colorInactive: ${brand.global.white};
    --clickPadding: 12px;
    --gap: 10px;
    --height: 12px;
    --width: 12px;
  }

  display: flex;
  flex-direction: row;
  gap: var(--gap);
  place-content: center;
  place-items: center;
  user-select: none;
`;
const Item = styled.button `
  ${ButtonReset};

  position: relative;
  display: grid;
  background: none;
  padding: var(--clickPadding) 0;
  place-content: center;
  height: var(--height);
  width: var(--width);

  &::before {
    ${transition('color')};

    content: '';
    display: block;
    background: none;
    background-image: linear-gradient(to right, currentColor, currentColor);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    grid-column: 1 / span 1;
    grid-row: 1 / span 1;

    ${Container}[data-site='mep'] & {
      border-radius: 100%;
    }
  }

  &::before {
    ${transition('color')};

    color: var(--colorInactive);
    height: var(--height);
    width: var(--width);

    ${Container}[data-site='mep'] & {
      border: 1px solid var(--colorActive);
    }
  }

  /* Enable focus styles for Safari */
  &:focus {
    outline: none;

    &::before {
      outline: auto;
      outline-color: currentColor;
      outline-offset: 5px;
      outline-width: thin;
    }
  }

  /* Enable hover styles for Safari */
  &:not(span):hover::before {
    color: var(--colorActive);
  }

  /* Disable focus styles if focus visible is supported */
  &:not(:focus-visible):focus {
    outline: none;
  }

  /* Reapply focus styles for focus-visible browsers */
  &:focus-visible {
    outline: none;

    &::before {
      outline: auto;
      outline-color: currentColor;
      outline-offset: 5px;
      outline-width: thin;
    }
  }

  /* Apply hover styles for focus-visible browsers */
  &:not(:focus-visible):hover::after {
    color: var(--colorActive);
  }

  /* Apply active styles */
  &[aria-current='true']::before {
    color: var(--colorActive);
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: var(--textColor);
  }
`;
const DotPaginationStyles = {
    Container,
    Item,
};
export default DotPaginationStyles;
